import React, {createRef, useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import {useAuth0} from "@auth0/auth0-react";
import __ from "lodash";
import parse from 'html-react-parser';
import axios from "axios";
import {Checkbox, Icon, IconButton, Tooltip, useTheme} from "@material-ui/core";
import MaterialTable from "@material-table/core";
import {defaultComponentsScroll, MaterialTableBody, FullWidthFilter} from "../../../controls/Material-Table-Components";
import SystemContext from "../../../SystemContext";
import {formatChars} from "../../../blocks/FormatCharacters";
import { getApiSitePrefix } from "../../../functions/SiteDefaults";
import useDimensions from "../../../blocks/useDimensions";
import {ColumnWidth, renderBooleanFilter} from "../../../blocks/ColumnHelper";
import {CheckboxEditor, MaskedText} from "../../../controls";
import { useUldTracker }  from "../../../services/uld";

const apiSitePrefix = getApiSitePrefix();
const dateFormat = "DD/MM/YYYY";


const UldList = (_props) => {
  const {isAuthenticated} = useAuth0();
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const eventBus = SystemData.eventBus;

  const props = {
    ..._props
  }
  const classes = props.classes;
  const [state] = useState({
    canEdit: props.canEdit,
    activeRow: null
  });

  const tableRef = createRef({state: {lastEditingRow: false}});

  const queryClient = useQueryClient();
  const extraKeys = ["distinct"];

  const rootMenuItems = useUldTracker({tableRef, queryClient, extraKeys});

  const handleRowClick = (event, rowData) => {
    if (rowData.tableData.index >= 0) {
      if (eventBus) {
        eventBus.trigger('UldTrackingList.rowSelected', rowData);
      }
    }
  }

  const getColumns = (props) => {
    const baseColumn = {
      cellStyle: { fontSize:13, padding: "0px 0px" },
      headerStyle: { padding: "8px 2px" },
      filterCellStyle: { padding: "8px 2px" },
      editable: state.canEdit?"always":"never",
      filterComponent: FullWidthFilter,
      sorting: false,
    };

    const defaultEditProps = {
      style:{fontSize: "0.875rem"}
    };

    return [
      /*
        Can use ...ColumnWidth(70) to generate a fixed width column
      */

      {
        ...baseColumn,
        ...ColumnWidth(150),
        title: "ULD Number",
        field: "uldNumber",
        initialEditValue: "",
        editComponent: (props) => (
          <MaskedText
            mask={"x".repeat(100)}
            maskChar={""}
            alwaysShowMask={false}
            formatChars={formatChars}
            value={props.value}
            onChange={props.onChange}
            inputProps={defaultEditProps}
          />
        )
      },
    ];
  };

  const [tableContainerRef, {height: tableHeight}] = useDimensions({});
  const theader = tableContainerRef.current?.querySelector('thead');
  const thead = theader ? theader.clientHeight:40;
  const bodyHeight = tableHeight - thead - 16;

  return (isAuthenticated &&
      <div style={{width: "100%", marginLeft: 20, marginRight: 20}}>
        <div style={{background: "#ffffff", width: "calc(100% - 24px)", paddingTop: 16, paddingLeft: 20, paddingRight: 4}}>
          <div ref={tableContainerRef} className={state.canEdit?classes.tariffHeaderListEdit:classes.tariffHeaderList} style={{width: "100%", minWidth: "100%", height: `calc(100vh - ${props.height + 16}px)`}}>
            <MaterialTable
              icons={{ Filter: React.forwardRef((props, ref) => <Icon className="filterIcon">filter_list</Icon> )}}
              tableRef={tableRef}
              style={{
                border: "none",
                boxShadow: "none",
                borderRadius: 0,
              }}
              onRowClick={handleRowClick}
              options={{
                tableRef,
                highlightRowStyle: {backgroundColor: "#F69259"},
                actionsColumnIndex: -99,
                cellStyle: {
                  padding: "8px 2px",
                },
                headerRowStyle: {
                  display: "table",
                  width: "100%",
                },
                headerStyle: {
                  backgroundColor: theme.palette.tableHeader.backgroundColor,
                  color: theme.palette.tableHeader.textColor,
                  padding: 2,
                },
                draggable: false,
                toolbar: false,
                toolbarButtonAlignment: "right",
                pageSize: 10,
                detailPanelType: "single",
                padding: 'dense',
                paging: false,
                filtering: true,
                searchFieldAlignment: "left",
              }}
              components={{
                ...defaultComponentsScroll,
                Body: (props) => (
                  <MaterialTableBody
                    {...props}
                    rowHeight={40}
                    overscanRowCount={10}
                    addVirtualScrolling={true}
                    bodyHeight={bodyHeight}
                    headerHeight={thead}
                    filterRowHeight={56}
                  />
                ),
              }}
              // actions={[
              //   (rowData) => (
              //     {
              //       icon: 'file_copy',
              //       tooltip: 'Duplicate',
              //       position: 'row',
              //       onClick: handleDuplicate,
              //       disabled: !state.canEdit,
              //       isFreeAction: false
              //     }
              //   )
              // ]}
              title="Menu Maintenance"
              columns={getColumns({canEdit: false})}
              data={rootMenuItems.data}
              editable={{
                isEditable: false,
                isDeletable: false,
                onRowAdd: undefined,
                onRowUpdate: undefined
              }}
            />
          </div>
        </div>
      </div>
  );

}

export default UldList;
